<script setup>
import { ref, defineProps} from 'vue'

const props = defineProps(['field'])
const field = ref(props.field)
</script>

<template>
  <table class="table table-bordered">
    <tbody>
      <tr>
        <th scope="row" class="bg-light text-center">作物</th>
        <td>{{ field?.Crop }}</td>
      </tr>
      <tr>
        <th scope="row" class="bg-light text-center">期間</th>
        <td>{{ field?.FromDT }} ～ {{ field?.ToDT }}</td>
      </tr>
      <tr>
        <th scope="row" class="bg-light text-center">担当</th>
        <td>{{ field?.Manager }}</td>
      </tr>
      <tr>
        <th scope="row" class="bg-light text-center">緯度・経度</th>
        <td>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">{{ field?.LatLng?.lat }}</li>
            <li class="list-group-item">{{ field?.LatLng?.lng }}</li>
          </ul>
        </td>
      </tr>
      <!-- <tr>
        <th scope="row" class="bg-dark-subtle">撮影日</th>
        <td>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="days in offCanvas.ShootingDays" :key="days">
              {{ days.toString().slice(0, 4) }}/{{ days.toString().slice(4, 6) }}/{{ days.toString().slice(6, 8) }}
            </li>
          </ul>
        </td>
      </tr> -->
    </tbody>
  </table>
</template>

<style scoped>
</style>
